import { Component, OnInit, ViewChild, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { JobsService } from 'src/app/service/jobs/jobs.service';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { UsersService } from 'src/app/service/users/users.service';
import { WorkingStatusService } from 'src/app/service/working-status/working-status.service';
import { JobAuditTrailService } from 'src/app/service/job-audit-trail/job-audit-trail.service';
import { IpAddressService } from 'src/app/service/ip-address/ip-address.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { PotentialJobsWorkingCommentsService } from 'src/app/service/potential-jobs-working-comments/potential-jobs-working-comments.service';
import { empty } from 'rxjs';
import { ExportToCsv } from 'export-to-csv';

import { Router } from '@angular/router';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-job-status',
  templateUrl: './job-status.component.html',
  styleUrls: ['./job-status.component.scss'],
})
export class JobStatusComponent implements OnInit {
  @ViewChild('invoiceTable') invoiceTable;
  @ViewChild('closeFilterModel') closeFilterModel;
  @ViewChild('closebutton1') closebutton1;

  jobsData = [];
  invoiceData = [];
  projectManagerData: any = [];
  userPermissions;
  ProjectAssistantData: any = [];
  workingStatusData: any = [];
  potentialJobsWorkingCommentsData: any = [];
  arCustomerData = [];
  searchInfo = {
    project_manager_id: '',
    assistant_id: '',
    contact_ar_customer_name_id: '',
    status: '1,2,3,4',
    search: '',
    working_status: '1,2,3,4',
    contact_type_of_billing: '',
    start: 0,
    limit: 150,
    field: '',
    order: '',
  };
  deleteJobId;
  ipAddress;
  userId;
  jobId;
  jobDetail;
  user_message;
  type = 'asc';
  messagesLoaded = false;
  lastDataNumber = 0;
  totalCount = 0;
  sortBy = '';

  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private router: Router,
    private loaderService: LoaderService,
    private jobsService: JobsService,
    private usersService: UsersService,
    private momentService: MomentService,
    private jobAuditTrailService: JobAuditTrailService,
    private ipAddressService: IpAddressService,
    private localStorageService: LocalstorageService,
    private workingStatusService: WorkingStatusService,
    private potentialJobsWorkingCommentsService: PotentialJobsWorkingCommentsService,
  ) {
    this.userId = this.localStorageService.getItem('userId');
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)

    //To get saved filter data if exist
    const filterData = this.localStorageService.getItem('invoiceFilter');
    if (filterData) {
      this.searchInfo = JSON.parse(filterData);
    }

    setTimeout(() => {
      this.setSelect2MultipleWithCheck();
    }, 1550);
  }

  loadToggle() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadInvoiceToggle();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadTooltip() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadTooltip();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadScroller() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadScroller();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  appendHTMLtoTag(obj, content) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'appendHTMLtoTag("' + obj + '",`' + content + '`);';
    this.renderer2.appendChild(this._document.body, s);
  }

  scrollToBottom(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'scrollToBottom("' + obj + '");';
    this.renderer2.appendChild(this._document.body, s);
  }

  clearHTMLforTag(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = 'clearHTMLforTag("' + obj + '");';
    this.renderer2.appendChild(this._document.body, s);
  }

  triggerChange(obj) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `triggerChange('` + obj + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2MultipleWithCheck('` + className + `','Working Status');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  clearSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearSelect2MultipleWithCheck('` + className + `');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  setSelect2MultipleWithCheck(className = '.select2MultipleWithCheck') {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `setSelect2MultipleWithCheck('` + className + `', [` + this.searchInfo['working_status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s);

    const s1 = this.renderer2.createElement('script');
    s1.type = 'text/javascript';
    s1.text = `setSelect2MultipleWithCheck('` + className + `', [` + this.searchInfo['status'] + `]);`;
    this.renderer2.appendChild(this._document.body, s1);
  }

  loadInvoiceDataOnScroll() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadInvoiceDataOnScroll();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  destroyUpdateDataTable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `destroyUpdateDataTable('.jobs-invoice-data-table');`;
    this.renderer2.appendChild(this._document.body, s);
  }

  ngOnInit(): void {
    this.loaderService.displayLoader();
    this.getJobs();
    this.loadToggle();
    this.getUsers();
    this.getARCustomer();
    this.getWorkingStatus();
    this.loadInvoiceDataOnScroll();
    setTimeout(() => {
      this.loadSelect2();
      this.loadSelect2MultipleWithCheck();
    }, 1500);
  }

  //To clear datatable
  clearDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('.jobs-invoice-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To clear datatable
  updateDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `updateDatatable('.jobs-invoice-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To draw datatable with data
  drawDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('.jobs-invoice-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  sortInvoiceData(className, field, type = null) {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `sortInvoiceData('.newInvoiceCustomerSortData','` + field + `','` + this.type + `')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To get all jobs
  getJobs(isConcat = false) {
    //Service call to get all jobs data
    this.jobsService.getInvoiceJobs(this.searchInfo).subscribe(
      res => this.onJobsSuccess(res, isConcat),
      error => this.onJobsError(error),
    );
  }

  //On success of jobs api call
  onJobsSuccess(result, isConcat = false) {
    if (result) {
      if (result.data) {
        if (result.data.data) {
          //Assign jobs result data to jobsData
          this.invoiceData = [];
          this.totalCount = result.data.count;

          if (isConcat) {
            this.jobsData = result.data.data;
          } else {
            this.jobsData = this.jobsData.concat(result.data.data);
          }

          if (this.jobsData) {
            this.lastDataNumber = this.jobsData.length;
          } else {
            this.lastDataNumber = 0;
          }

          let count = 0;

          if (result.data.data.length > 0) {
            this.jobsData.forEach(element => {
              count++;
              if (
                element.assistant_id != 0 &&
                element.assistant_id != '' &&
                element.assistant_id != null &&
                element.assistant_id != undefined
              ) {
                if (!this.invoiceData[element.assistant_id]) {
                  this.invoiceData[element.assistant_id] = [];
                  this.invoiceData[element.assistant_id].name = element.project_assistant_name;
                }

                if (!this.invoiceData[element.assistant_id]['data']) {
                  this.invoiceData[element.assistant_id]['data'] = [];
                }

                if (!this.invoiceData[element.assistant_id]['data'][element.project_manager_id]) {
                  this.invoiceData[element.assistant_id]['data'][element.project_manager_id] = [];
                  this.invoiceData[element.assistant_id]['data'][element.project_manager_id].name =
                    element.project_manager_name;
                }

                if (!this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data']) {
                  this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data'] = [];
                }
                if (this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data']) {
                  this.invoiceData[element.assistant_id]['data'][element.project_manager_id]['data'].push(element);
                }
              }

              if (this.jobsData.length == count) {
                if (this.invoiceData.length > 0) {
                  this.createTableStuctureWithData();
                } else {
                  this.loadMoreData();
                }
              }
            });
          }
        } else {
          this.loaderService.hideLoader();
        }
      } else {
        this.loaderService.hideLoader();
      }
    }
  }

  createTableStuctureWithData(type = 'asc') {
    this.loaderService.displayLoader();
    this.clearHTMLforTag('#invoiceTable');
    this.destroyUpdateDataTable();
    let html;
    html +=
      `<thead>
                <tr>
                <th width="130" class="group-word tablesorter-header tablesorter-headerUnSorted" onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.name','` +
      this.type +
      `')">Project Manager</th>
                    <th width="130" class="group-word tablesorter-header tablesorter-headerUnSorted" onclick="sortInvoiceData('.newInvoiceCustomerSortData','o.owner_name','` +
      this.type +
      `')">Owner</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted" onclick="sortInvoiceData('.newInvoiceCustomerSortData','f.facility_name','` +
      this.type +
      `')">Location</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.job_creation_date','` +
      this.type +
      `')">Job Created</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.number','` +
      this.type +
      `')">Job #</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','departments_list','` +
      this.type +
      `')">Job Dept</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','ac.customer_id','` +
      this.type +
      `')">AR Cust ID</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.contact_type_of_billing','` +
      this.type +
      `')">Billing Type</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.description','` +
      this.type +
      `')">Job Description</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.working_status','` +
      this.type +
      `')">Job Setup Progress</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.working_status','` +
      this.type +
      `')">Working Status</th>
                    <th class="tablesorter-header tablesorter-headerUnSorted"  onclick="sortInvoiceData('.newInvoiceCustomerSortData','j.working_status','` +
      this.type +
      `')">STA</th>
                    <!-- <th class="tablesorter-header tablesorter-headerUnSorted">Job Status</th>-->
                    <th class="sorter-false" width="100"></th>
                </tr>
            </thead>`;
    this.appendHTMLtoTag('#invoiceTable', html);
    this.sortByKey(this.invoiceData, 'name', this.type);
    this.invoiceData.forEach((result1, index) => {
      let html1;
      if (result1) {
        html1 +=
          `<tbody class="header">
                  <tr class="accordion-header">
                    <td>
                      <div class="collapsible-row">
                        <div style="cursor:pointer" class="font-weight-bold">
                        <span onClick="toggleAccordion(${index})" data-id="${index}">
                          ${result1.name}
                        </span>
                        </div>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                        <a href="javascript:;" id="toggle-row-${index}" class="far d-inline toggle-icon" data-id="` +
          index +
          `"></a>
                    </td>
                  </tr>
                </tbody>`;
        this.appendHTMLtoTag('#invoiceTable', html1);

        if (result1.data.length > 0) {
          this.sortByKey(result1.data, 'name', this.type);
          result1.data.forEach(async result2 => {
            let html2 = '';
            if (result2) {
              html2 +=
                `<tbody class="content` +
                index +
                `">
                      <tr class="accordion-header-subtitle tablesorter-infoOnly"  data-row-index="8" id="content` +
                index +
                `">
                        <td>
                          <div class="collapsible-row">
                            <div style="cursor:pointer" class="font-weight-bold">
                            <span onClick="toggleAccordion1(${index})" data-id="${index}">
                              ${result2.name}
                            </span>
                            </div>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                        <a href="javascript:;" class="far d-inline toggle-icon1" id="toggle-row1-${index}" onclick="triggerUpdateAll()" data-id="` +
                index +
                `" ></a>
                    </td>
                      </tr>
                      </tbody>
                      <tbody class="content` +
                index +
                `">`;

              let datalength, count, result3;
              if (result2.data.length > 0) {
                datalength = result2.data.length;
                count = 0;
                for (let i = 0; i < result2.data.length; i++) {
                  result3 = result2.data[i];
                  count++;
                  let html3 = '';
                  if (result3.status == 5) {
                    html2 +=
                      `<tr class="status-row closed">
                              <td><span class="label">CLOSED</span> ` +
                      (result3.project_manager_name != null &&
                        result3.project_manager_name != '' &&
                        result3.project_manager_name != undefined &&
                        result3.project_manager_name != 0
                        ? result3.project_manager_name
                        : '') +
                      `</td>`;
                  } else {
                    html2 +=
                      `<tr>
                              <td>` +
                      (result3.project_manager_name != null &&
                        result3.project_manager_name != '' &&
                        result3.project_manager_name != undefined &&
                        result3.project_manager_name != 0
                        ? result3.project_manager_name
                        : '') +
                      `</td>`;
                  }
                  let percentage = 0;
                  let progressBar = 'danger';
                  if (result3.working_status == 1) {
                    percentage = 20;
                    progressBar = 'bg-scale-1';
                  } else if (result3.working_status == 2) {
                    percentage = 40;
                    progressBar = 'bg-scale-2';
                  } else if (result3.working_status == 3) {
                    percentage = 60;
                    progressBar = 'bg-scale-3';
                  } else if (result3.working_status == 4) {
                    percentage = 80;
                    progressBar = 'bg-scale-4';
                  } else if (result3.working_status == 5) {
                    percentage = 100;
                    progressBar = 'bg-scale-5';
                  }
                  html2 +=
                    `
                  <td>` +
                    (result3.owner_name != null &&
                      result3.owner_name != '' &&
                      result3.owner_name != undefined &&
                      result3.owner_name != 0
                      ? result3.owner_name
                      : '') +
                    `</td>
                            <td>` +
                    (result3.facility_name != null &&
                      result3.facility_name != '' &&
                      result3.facility_name != undefined &&
                      result3.facility_name != 0
                      ? result3.facility_name
                      : '') +
                    `</td>
                            <td>` +
                    (result3.job_creation_date != null &&
                      result3.job_creation_date != '' &&
                      result3.job_creation_date != undefined
                      ? this.momentService.getDateWithFormat(result3.job_creation_date, 'M/D/YY')
                      : '') +
                    `</td>
                            <td width="8%"><a href="/jobs/${result3.id}" class="text-blue">` +
                    (result3.number != null &&
                      result3.number != '' &&
                      result3.number != undefined &&
                      result3.number != 0
                      ? result3.number
                      : '') +
                    `</a></td>
                            <td>` +
                    (result3.departments_list != null &&
                      result3.departments_list != '' &&
                      result3.departments_list != undefined &&
                      result3.departments_list != 0
                      ? result3.departments_list
                      : '') +
                    `</td>
                            <td width="8%">` +
                    (result3.customer_id != null &&
                      result3.customer_id != '' &&
                      result3.customer_id != undefined &&
                      result3.customer_id != 0
                      ? result3.customer_id
                      : '') +
                    `</td>
                            <td>` +
                    (result3.contact_type_of_billing == 1
                      ? 'QB'
                      : result3.contact_type_of_billing == 2
                        ? 'Cont'
                        : 'AIA') +
                    `</td>
                            <td>` +
                    (result3.description != null && result3.description != '' && result3.description != undefined
                      ? result3.description
                      : '') +
                    `</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="progress-value">` +
                    percentage +
                    `%</div>
                                    <div class="progress">
                                        <div class="progress-bar ` +
                    progressBar +
                    `" role="progressbar" style="width: ` +
                    percentage +
                    `%"
                                            aria-valuenow="` +
                    percentage +
                    `" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="tooltip-icon" data-toggle="tooltip" data-html="true" data-original-title="` +
                    (result3.working_status_name == 'Pulled'
                      ? 'Job to be setup in Sage'
                      : result3.working_status_name == 'Basics'
                        ? 'Need: Estimates, Contract & SOV breakdown, Required Fields'
                        : result3.working_status_name == 'Estimates'
                          ? 'Need: Contract & SOV Breakdown, Required Fields'
                          : result3.working_status_name == 'Contracts & SOV'
                            ? 'Need: Final Project Details (Required fields) '
                            : result3.working_status_name == 'Setup Complete'
                              ? ' Project Setup Complete'
                              : result3.working_status_name) +
                    `"><i class="fas fa-info-circle"></i>
                                    </span>
                                </div>
                            </td>
                            <td>` +
                    result3.working_status_name +
                    `</td>
                    <td>` +
                    (result3.submit_to_accounting ?
                      `<span class="status-icon" *ngIf="item.submit_to_accounting">
                            <i class="far fa-check"></i>
                        </span>` : '') +
                    `</td>
                           <!-- <td>` +
                    (result3.status == 0
                      ? '<span class="btn btn-info btn-icon d-flex justify-content-between">Started <i class="fal fa-info-circle" data-toggle="tooltip" data-html="true" data-original-title="Started"></i></span>'
                      : result3.status == 1
                        ? '<span class="btn btn-success btn-icon d-flex justify-content-between">Active <i class="fal fa-info-circle" data-toggle="tooltip" data-html="true" data-original-title="Active"> </i></span>'
                        : result3.status == '2'
                          ? '<span class="btn btn-danger btn-icon d-flex justify-content-between">Closed <i class="fal fa-info-circle"  data-toggle="tooltip" data-html="true" data-original-title="Closed"></i></span>'
                          : '<span class="btn btn-danger btn-icon d-flex justify-content-between">Deleted <i class="fal fa-info-circle" data-toggle="tooltip" data-html="true" data-original-title="Deleted"></i></span>') +
                    `</td> -->
                            <td><div class="d-flex justify-content-between align-items-center">
                                    <a href="javascript:;" class="comment" id="` +
                    result3.id +
                    `" data-toggle="modal" data-target="#chat-modal"
                            onclick="setChatJobId('` +
                    result3.id +
                    `')">
                                        <i class="fas fa-comment-alt"></i>
                                    </a>
                                    <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

                                </div>

                            </td>
                          </tr>`;
                }
              }

              if (datalength == count) {
                let html4 = '';
                html2 += `</tbody>`;
                this.appendHTMLtoTag('#invoiceTable', html2);
              }
            }
          });
        }
      }
    });
    setTimeout(() => {
      setTimeout(() => {
        this.loadToggle();
        this.updateDatatable();
        this.loadTooltip();
        this.loadScroller();
        this.setCommentIconColor();
      }, 100);

      this.loaderService.hideLoader();
    }, 500);
  }
  setCommentIconColor() {
    var x = document.getElementsByClassName('comment');
    var i;
    for (i = 0; i < x.length; i++) {
      this.getClassData(x[i].getAttribute('id'));
    }
  }

  async getClassData(id) {
    return new Promise((resolve, reject) => {
      this.potentialJobsWorkingCommentsService
        .getPotentialJobsWorkingCommentsByJobId(id, 'job', {
          includeInvoices: 1,
        })
        .subscribe(
          result => {
            if (result) {
              if (result.data) {
                if (result.data.length > 0) {
                  resolve(document.getElementById(id).classList.add('danger'));
                  // resolve(`<div class="d-flex justify-content-between align-items-center">
                  //                     <a href="javascript:;" class="comment danger" id="`+ id + `" data-toggle="modal" data-target="#chat-modal"
                  //             onclick="setChatJobId('`+ id + `')">
                  //                         <i class="fas fa-comment-alt"></i>
                  //                     </a>
                  //                     <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
                  //                         aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

                  //                 </div>`);
                } else {
                  resolve(document.getElementById(id).classList.remove('danger'));
                  // resolve(`<div class="d-flex justify-content-between align-items-center">
                  //                     <a href="javascript:;" class="comment" id="`+ id + `" data-toggle="modal" data-target="#chat-modal"
                  //             onclick="setChatJobId('`+ id + `')">
                  //                         <i class="fas fa-comment-alt"></i>
                  //                     </a>
                  //                     <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
                  //                         aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

                  //                 </div>`);
                }
              } else {
                resolve(document.getElementById(id).classList.remove('danger'));
                // resolve(`<div class="d-flex justify-content-between align-items-center">
                //                       <a href="javascript:;" class="comment" id="`+ id + `" data-toggle="modal" data-target="#chat-modal"
                //               onclick="setChatJobId('`+ id + `')">
                //                           <i class="fas fa-comment-alt"></i>
                //                       </a>
                //                       <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
                //                           aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

                //                   </div>`);
              }
            }
          },
          error => {
            resolve(document.getElementById(id).classList.add('danger'));
            // resolve(`<div class="d-flex justify-content-between align-items-center">
            //                           <a href="javascript:;" class="comment" id="`+ id + `" data-toggle="modal" data-target="#chat-modal"
            //                   onclick="setChatJobId('`+ id + `')">
            //                               <i class="fas fa-comment-alt"></i>
            //                           </a>
            //                           <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
            //                               aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

            //                       </div>`);
          },
        );
    });
  }

  setSortField(value) {
    this.sortBy = value;
  }

  loadMoreData() {
    if (this.lastDataNumber != 0) {
      if (this.lastDataNumber <= this.totalCount) {
        this.searchInfo.start = this.lastDataNumber;
        this.getJobs();
      }
    }
  }

  //On error of jobs api call
  onJobsError(error) {
    this.loaderService.hideLoader();
  }

  getJobProcessPercentage(item) {
    return item.working_status == 1
      ? 20
      : item.working_status == 2
        ? 40
        : item.working_status == 3
          ? 60
          : item.working_status == 4
            ? 80
            : 100;
  }

  getProgressBarHtml(item) {
    let html =
      `<div class="d-flex align-items-center">
                                    <div class="progress-value">` +
      this.getJobProcessPercentage(item) +
      `%</div>
                                    <div class="progress">
                                        <div class="progress-bar bg-scale-` +
      item.working_status +
      `" role="progressbar" style="width: ` +
      this.getJobProcessPercentage(item) +
      `%"
                                            aria-valuenow="` +
      this.getJobProcessPercentage(item) +
      `" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <span class="tooltip-icon" data-toggle="tooltip" data-html="true" data-original-title="` +
      (item.working_status_name == 'Pulled'
        ? 'Job to be setup in Sage Basics - Need: Estimates, Contract & SOV breakdown, Required Fields'
        : item.working_status_name == 'Estimates'
          ? 'Need: Contract & SOV Breakdown, Required Fields'
          : item.working_status_name == 'Contracts & SOV'
            ? 'Need: Final Project Details (Required fields) Setup Complete - Project Setup Complete'
            : item.working_status_name) +
      `"><i class="fas fa-info-circle"></i>
                                    </span>
                                </div>`;
    return html;
  }

  getActionHtml(item) {
    return (
      `<div class="d-flex justify-content-between align-items-center">
                                    <a href="javascript:;" class="comment" data-toggle="modal" data-target="#chat-modal"
                            onclick="setChatJobId('` +
      item.id +
      `')">
                                        <i class="fas fa-comment-alt"></i>
                                    </a>
                                    <a href="#" class="action-dropdown ml-3" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false"><i class="fas fa-ellipsis-v"></i></a>

                                </div>`
    );
  }

  //To save filter data
  saveFilter() {
    this.localStorageService.setItem('invoiceFilter', JSON.stringify(this.searchInfo));
    this.getJobs(true);
  }

  //To clear filter data
  clearFilter() {
    this.localStorageService.removeItem('invoiceFilter');
    this.searchInfo = {
      project_manager_id: '',
      assistant_id: '',
      contact_ar_customer_name_id: '',
      status: '1,2,3,4',
      search: '',
      working_status: '1,2,3,4',
      contact_type_of_billing: '',
      start: 0,
      limit: 150,
      field: '',
      order: '',
    };
    this.getJobs(true);
    this.triggerChange('#project_manager_id');
    this.triggerChange('#assistant_id');
    this.triggerChange('#projectAssistant1');
    this.triggerChange('#arCustomer');
    this.triggerChange('#working_status');
    this.triggerChange('#status');
    this.triggerChange('#billingType');
    this.clearSelect2MultipleWithCheck();
    this.setSelect2MultipleWithCheck();
  }

  sortByKey(array, key, type = 'asc') {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      if (type == 'asc') {
        return x < y ? -1 : x > y ? 1 : 0;
      } else {
        return x > y ? -1 : x < y ? 1 : 0;
      }
    });
  }

  //To get all users
  getUsers() {
    //Service call to get all users data
    this.usersService.getUsers().subscribe(
      res => this.onUsersSuccess(res),
      error => this.onUsersError(error),
    );
  }

  //On success of users api call
  onUsersSuccess(result) {
    if (result) {
      if (result.data) {
        //Assign users result data to projectManagerData, projectForemanData and ProjectAssistantData
        this.projectManagerData = result.data.filter(function (item) {
          return (item.role_id == 4 || item.role_id == 14) && item.status == 1;
        });
        this.ProjectAssistantData = result.data.filter(function (item) {
          return item.role_id == 7 && item.status == 1;
        });
      }
    }
  }

  //On error of departments api call
  onUsersError(error) { }

  //To get all arcustomer data
  getARCustomer() {
    this.jobsService.getARCustomer().subscribe(
      res => this.onARCustomerSuccess(res),
      error => this.onARCustomerError(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerSuccess(result) {
    if (result) {
      if (result.data) {
        this.arCustomerData = result.data;
      } else {
      }
    }
  }

  //On error of arcustomer api call
  onARCustomerError(error) { }

  //Set search parameter and get filter data
  searchInTable(
    value,
    key,
    value1 = '',
    key1 = '',
    value2 = '',
    key2 = '',
    value3 = '',
    key3 = '',
    value4 = '',
    key4 = '',
    value5 = '',
    key5 = '',
  ) {
    if (key == 'working_status') {
      if (value == '' || value == null || value == undefined) {
        // value = '1,2,3,4';
      }
    }
    if (
      this.searchInfo['working_status'] == '' ||
      this.searchInfo['working_status'] == null ||
      this.searchInfo['working_status'] == undefined
    ) {
      // value = '1,2,3,4';
    }

    if (key == 'status') {
      if (value == '' || value == null || value == undefined) {
        value = '1,2,3,4';
      }
    }
    if (
      this.searchInfo['status'] == '' ||
      this.searchInfo['status'] == null ||
      this.searchInfo['status'] == undefined
    ) {
      value = '1,2,3,4';
    }
    if (value == '') {
      delete this.searchInfo[key];
    }
    if (key1 != '') {
      if (value1 != '') {
        this.searchInfo[key1] = value1;
      } else if (value1 == '') {
        delete this.searchInfo[key1];
      }
      this.closeFilterModel.nativeElement.click();
    }
    if (key2 != '') {
      if (value2 != '') {
        this.searchInfo[key2] = value2;
      } else if (value2 == '') {
        delete this.searchInfo[key2];
      }
    }
    if (key3 != '') {
      if (value3 != '') {
        this.searchInfo[key3] = value3;
      } else if (value3 == '') {
        delete this.searchInfo[key3];
      }
    }
    if (key4 != '') {
      if (value4 != '') {
        this.searchInfo[key4] = value4;
      } else if (value4 == '') {
        delete this.searchInfo[key4];
      }
    }
    if (key5 != '') {
      if (value5 != '') {
        this.searchInfo[key5] = value5;
      } else if (value5 == '') {
        delete this.searchInfo[key5];
      }
    }

    this.searchInfo[key] = value;
    this.searchInfo.start = 0;
    this.clearHTMLforTag('#invoiceTable');
    this.getJobs(true);
  }

  //To get all working status
  getWorkingStatus() {
    //Service call to get all working status data
    this.workingStatusService.getWorkingStatus().subscribe(
      res => this.onWorkingStatusSuccess(res),
      error => this.onWorkingStatusError(error),
    );
  }

  //On success of working status api call
  onWorkingStatusSuccess(result) {
    if (result) {
      if (result.data) {
        this.workingStatusData = result.data;
      }
    }
  }

  //On error of working wtatus api call
  onWorkingStatusError(error) { }

  //To get all potential jobs working comments
  getPotentialJobsWorkingComments(jobId) {
    this.messagesLoaded = false;
    this.jobId = jobId;
    let jobResult = this.jobsData.filter(function (item) {
      return item.id == jobId;
    });

    if (jobResult.length > 0) {
      this.jobDetail = jobResult[0];
    }

    //Service call to get all working comments data
    this.potentialJobsWorkingCommentsService
      .getPotentialJobsWorkingCommentsByJobId(jobId, 'job', {
        includeInvoices: 1,
      })
      .subscribe(
        res => this.onPotentialJobsWorkingCommentsSuccess(res),
        error => this.onPotentialJobsWorkingCommentsError(error),
      );
  }

  //On success of working status api call
  onPotentialJobsWorkingCommentsSuccess(result) {
    if (result) {
      if (result.data) {
        this.potentialJobsWorkingCommentsData = result.data;
        this.messagesLoaded = true;
        setTimeout(() => {
          this.scrollToBottom('chatBlock');
        }, 500);
      }
    }
  }

  //On error of working wtatus api call
  onPotentialJobsWorkingCommentsError(error) { }

  //Get first department short code from department list
  getDepartmentFromList(depList) {
    let newArr = depList.split(',');
    if (newArr) {
      if (newArr[0]) {
        return newArr[0];
      }
    }
  }

  //To formate date in chat box
  getFormattedDate(date) {
    if (date != null && date != undefined) {
      return this.momentService.getDateWithFormat(date, 'M/DD/YYYY h:m A');
    } else {
      return '';
    }
  }

  //To send message from chat pop up
  sendMessage() {
    if (this.user_message != null) {
      this.createPotentialJobsWorkingComments();
    }
  }

  //To get all potential jobs working comments
  createPotentialJobsWorkingComments() {
    this.messagesLoaded = false;
    let newCommentArr = {};
    newCommentArr['potential_job_detail_id'] = this.jobId;
    newCommentArr['comment'] = this.user_message;
    newCommentArr['user_id'] = this.userId;

    //Service call to create new working comments data
    this.potentialJobsWorkingCommentsService.createPotentialJobsWorkingComments(newCommentArr).subscribe(
      res => this.onPotentialJobsWorkingCommentsSaveSuccess(res),
      error => this.onPotentialJobsWorkingCommentsSaveError(error),
    );
  }

  //On success of working status api call
  onPotentialJobsWorkingCommentsSaveSuccess(result) {
    if (result) {
      if (result.data) {
        this.getPotentialJobsWorkingComments(this.jobId);
        if (!document.getElementById(this.jobId).classList.contains('danger')) {
          document.getElementById(this.jobId).classList.add('danger');
        }
        this.user_message = '';
      }
    }
  }

  //On error of working wtatus api call
  onPotentialJobsWorkingCommentsSaveError(error) { }

  sortInvoiceCustomerData(type) {
    let data = type.split(',');

    if (data[1].trim() == 'asc') {
      this.type = 'desc';
    } else {
      this.type = 'asc';
    }

    this.searchInfo.order = this.type;
    this.searchInfo.field = data[0];
    this.searchInfo.start = 0;
    this.getJobs(true);
  }

  generateCSV() {
    const options = {
      filename: 'Invoice Data Export CSV',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);

    let userExport = [];
    this.invoiceData.forEach(element1 => {
      let newData1 = {
        'Project Manager': element1.name,
        Owner: '',
        Location: '',
        'Job Created': '',
        'Job #': '',
        'Job Departments': '',
        'AR Customer ID': '',
        'Billing Type': '',
        'Job Description': '',
        'Job Setup Progress': '',
        'Working Status': '',
        'STA': '',
        'Job Status': '',
      };
      userExport.push(newData1);

      element1.data.forEach(element2 => {
        let newData2 = {
          'Project Manager': element2.name,
          Owner: '',
          Location: '',
          'Job Created': '',
          'Job #': '',
          'Job Departments': '',
          'AR Customer ID': '',
          'Billing Type': '',
          'Job Description': '',
          'Job Setup Progress': '',
          'Working Status': '',
          'STA': '',
          'Job Status': '',
        };
        userExport.push(newData2);

        element2.data.forEach(result3 => {
          let percentage = 0;
          if (result3.working_status == 1) {
            percentage = 20;
          } else if (result3.working_status == 2) {
            percentage = 40;
          } else if (result3.working_status == 3) {
            percentage = 60;
          } else if (result3.working_status == 4) {
            percentage = 80;
          } else if (result3.working_status == 5) {
            percentage = 100;
          }

          let newData3 = {
            'Project Manager':
              result3.project_manager_name != null &&
                result3.project_manager_name != '' &&
                result3.project_manager_name != undefined &&
                result3.project_manager_name != 0
                ? result3.project_manager_name
                : '',
            Owner:
              result3.owner_name != null &&
                result3.owner_name != '' &&
                result3.owner_name != undefined &&
                result3.owner_name != 0
                ? result3.owner_name
                : '',
            Location:
              result3.facility_name != null &&
                result3.facility_name != '' &&
                result3.facility_name != undefined &&
                result3.facility_name != 0
                ? result3.facility_name
                : '',
            'Job Created':
              result3.job_creation_date != null &&
                result3.job_creation_date != '' &&
                result3.job_creation_date != undefined
                ? this.momentService.getDateWithFormat(result3.job_creation_date, 'MM-DD-YYYY')
                : '',
            'Job #':
              result3.number != null && result3.number != '' && result3.number != undefined && result3.number != 0
                ? result3.number
                : '',
            'Job Departments':
              result3.departments_list != null &&
                result3.departments_list != '' &&
                result3.departments_list != undefined &&
                result3.departments_list != 0
                ? result3.departments_list
                : '',
            'AR Customer ID':
              result3.customer_id != null &&
                result3.customer_id != '' &&
                result3.customer_id != undefined &&
                result3.customer_id != 0
                ? result3.customer_id
                : '',
            'Billing Type':
              result3.contact_type_of_billing == 1
                ? 'Quick Bill'
                : result3.contact_type_of_billing == 2
                  ? 'Contract'
                  : 'AIA',
            'Job Description':
              result3.description != null && result3.description != '' && result3.description != undefined
                ? result3.description
                : '',
            'Job Setup Progress': percentage,
            'Working Status': result3.working_status_name,
            'STA': result3.submit_to_accounting == 1 ? 'Yes' : 'No',
            'Job Status':
              result3.status == 0
                ? 'Deleted'
                : result3.status == 1
                  ? 'Started'
                  : result3.status == '2' || result3.status == '3' || result3.status == '4'
                    ? 'Active'
                    : 'Closed',
          };
          userExport.push(newData3);
        });
      });
    });

    csvExporter.generateCsv(userExport);
  }

  checkIsSelected(id, type) {
    let searchData = this.searchInfo[type];
    if (searchData.includes(id)) {
      return true;
    } else {
      return false;
    }
  }
}
